/**
 * Flutter access of localStorage in iOS is prevented due to a security policy.
 * Data for the webview is passed down in window.appStorage
 * @returns void
 */
export const importAppStorage = () => {
    if (typeof window.appStorage === 'undefined') return;
    window.appStorage.forEach((value, key) => {
        localStorage.setItem(key, value);
    });
}